/**
 * 流程图节点执行态样式（设计器无 _execStatus 时用各节点默认色）
 * done=已完成 / rejected=被退回 / pending=进行中 / idle=未开始
 */
export const EXEC_STATUS = {
  done: {
    fill: '#F6FFED',
    stroke: '#52C41A',
    text: '#389E0D',
    icon: '#52C41A',
  },
  rejected: {
    fill: '#FFF1F0',
    stroke: '#FF4D4F',
    text: '#CF1322',
    icon: '#FF4D4F',
  },
  pending: {
    fill: '#E6F7FF',
    stroke: '#1890FF',
    text: '#096DD9',
    icon: '#1890FF',
  },
  idle: {
    fill: '#FAFAFA',
    stroke: '#BFBFBF',
    text: '#8C8C8C',
    icon: '#BFBFBF',
  },
};

export function resolveExecStyle(properties = {}, fallback = null) {
  const st = properties && properties._execStatus;
  if (st && EXEC_STATUS[st]) {
    return EXEC_STATUS[st];
  }
  return fallback || EXEC_STATUS.pending;
}
